"use client";

import { Flex, Text } from "@radix-ui/themes";
import _ from "lodash";
import { useEffect, useState } from "react";
import { useCommSettingsStore } from "@/app/voice-settings";
import { DoNotDisturbStatusEnum } from "@/clients/ntas/basic-selfcare";
import { MoonIcon, RestrictedAccess } from "@/public/index";

export default function DndBanner() {
    const [isActive, setIsActive] = useState<DoNotDisturbStatusEnum>(DoNotDisturbStatusEnum.Off);
    const { commSettings, deltaForPatch } = useCommSettingsStore();
    const [isBlockingAllIncoming, setIsBlockingAllIncoming] = useState<boolean>(_.get(commSettings, "callBlocking.blkAll") ? true : false);

    useEffect(() => {
        if (commSettings?.doNotDisturb && !deltaForPatch?.doNotDisturb) setIsActive(_.get(commSettings, "doNotDisturb.status") || DoNotDisturbStatusEnum.Off);
        setIsBlockingAllIncoming(_.get(commSettings, "callBlocking.blkAll") ? true : false);
    }, [commSettings, commSettings.doNotDisturb, deltaForPatch, deltaForPatch.doNotDisturb]);

    return (
        <>
            {isActive === DoNotDisturbStatusEnum.On && !isBlockingAllIncoming && (
                <Flex gap="2" className="bg-att-cobalt-blue text-white justify-center items-center p-2 h-[46px] text-lg">
                    <MoonIcon />
                    <Text>
                        <strong>Do Not Disturb is on</strong> All incoming calls will be redirected to a busy tone.
                    </Text>
                </Flex>
            )}

            {isBlockingAllIncoming && (
                <Flex gap="2" className="bg-att-cobalt-blue text-white justify-center items-center p-2 h-[46px] text-lg">
                    <RestrictedAccess />
                    <Text>
                        <strong>Block all incoming calls is ON</strong> This stops all incoming calls from reaching this phone number.
                    </Text>
                </Flex>
            )}
        </>
    );
}
